<template>
  <div>
    <div
      style="
        display: flex;
        align-items: center;
        padding-block: 10px;
        padding-inline: 20px;
        margin-top: 20px;
      "
    >
      <div class="info-header">Store Daily Close/Open</div>
    </div>
    <div style="padding-bottom: 20px">
      <v-layout row wrap>
        <v-flex class="pa-4">
          <section id="subsec01" v-for="item in timeItems" :key="item.days">
            <div style="margin-bottom: 10px"></div>
            <v-layout row justify-start>
              <v-flex xs1 style="margin-top: 20px; text-align: center">
                <span>{{ item.days }}</span>
              </v-flex>
              <v-flex xs4 class="text-xs-center">
                <vue-timepicker
                  @change="selectedTimeOpen($event, item.day_id)"
                  format="HH:mm"
                  class="timePicker innerstore-timepicker"
                  v-if="dialog == true"
                  v-model="storeTime[(item.day_id - 1) * 2].store_time_open"
                ></vue-timepicker>
              </v-flex>
              <v-flex xs1 style="margin-top: 20px; text-align: center">
                <span>to</span>
              </v-flex>
              <v-flex xs4 class="text-xs-center">
                <vue-timepicker
                  @change="selectedTimeClose($event, item.day_id)"
                  class="timePicker innerstore-timepicker"
                  v-if="dialog == true"
                  v-model="storeTime[(item.day_id - 1) * 2].store_time_close"
                ></vue-timepicker>
              </v-flex>
              <v-flex v-if="item.more == false">
                <v-icon
                  large
                  class="mt-3"
                  color="green"
                  @click="item.more = true"
                  >add_box</v-icon
                >
              </v-flex>
            </v-layout>
            <v-layout row justify-start v-if="item.more">
              <v-flex xs1></v-flex>
              <v-flex xs4 class="text-xs-center">
                <vue-timepicker
                  @change="selectedTimeOpen2($event, item.day_id)"
                  :minute-interval="15"
                  class="timePicker innerstore-timepicker"
                  v-if="dialog == true"
                  v-model="storeTime[item.day_id * 2 - 1].store_time_open"
                ></vue-timepicker>
              </v-flex>
              <v-flex xs1 style="margin-top: 20px; text-align: center">
                <span>to</span>
              </v-flex>
              <v-flex xs4 class="text-xs-center">
                <vue-timepicker
                  @change="selectedTimeClose2($event, item.day_id)"
                  :minute-interval="15"
                  class="timePicker innerstore-timepicker"
                  v-if="dialog == true"
                  v-model="storeTime[item.day_id * 2 - 1].store_time_close"
                ></vue-timepicker>
              </v-flex>

              <v-flex>
                <v-icon
                  large
                  class="mt-3"
                  color="red"
                  @click="indeterminateTime(item, item.day_id)"
                >
                  indeterminate_check_box</v-icon
                >
              </v-flex>
            </v-layout>
            <div style="margin-bottom: 20px"></div>
            <v-divider></v-divider>
          </section>
        </v-flex>
      </v-layout>
      <div
        style="
          display: flex;
          justify-content: flex-end;
          padding-block: 10px;
          padding-inline: 20px;
        "
      >
        <v-btn @click="updateDineInStoreTime" color="#fddf00"
          ><strong> Update </strong>
        </v-btn>
      </div>
      <v-dialog v-model="error_dialog" persistent max-width="500">
        <v-card>
          <div
            style="
              background-color: #fddf00;
              height: 60px;
              display: flex;
              align-items: center;
              padding-left: 20px;
            "
          >
            <v-icon large style="margin-right: 10px" color="black"
              >warning</v-icon
            >
            <div style="font-size: 1.8rem">Warning</div>
          </div>
          <v-card-title class="headline" primary-title
            >Time's incorrect. Please check!</v-card-title
          >

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red" flat @click="error_dialog = false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
export default {
  props: ["store_time_id"],
  data: () => ({
    valid: false,
    dialog: true,
    error_dialog: false,
    timeItems: [
      {
        day_id: 1,
        days: "Sun",
        more: false,
      },
      {
        day_id: 2,
        days: "Mon",
        more: false,
      },
      {
        day_id: 3,
        days: "Tue",
        more: false,
      },
      {
        day_id: 4,
        days: "Wed",
        more: false,
      },
      {
        day_id: 5,
        days: "Thu",
        more: false,
      },
      {
        day_id: 6,
        days: "Fri",
        more: false,
      },
      {
        day_id: 7,
        days: "Sat",
        more: false,
      },
    ],
    error_dialog: false,
    success_dialog: false,
    failed_dialog: false,
    error_text: "",
    storeTime: [
      {
        store_time_open: { HH: "", mm: "" },
        store_time_close: { HH: "", mm: "" },
        store_day: 1,
        store_period: 1,
      },
      {
        store_time_open: { HH: "", mm: "" },
        store_time_close: { HH: "", mm: "" },
        store_day: 1,
        store_period: 2,
      },
      {
        store_time_open: { HH: "", mm: "" },
        store_time_close: { HH: "", mm: "" },
        store_day: 2,
        store_period: 1,
      },
      {
        store_time_open: { HH: "", mm: "" },
        store_time_close: { HH: "", mm: "" },
        store_day: 2,
        store_period: 2,
      },
      {
        store_time_open: { HH: "", mm: "" },
        store_time_close: { HH: "", mm: "" },
        store_day: 3,
        store_period: 1,
      },
      {
        store_time_open: { HH: "", mm: "" },
        store_time_close: { HH: "", mm: "" },
        store_day: 3,
        store_period: 2,
      },
      {
        store_time_open: { HH: "", mm: "" },
        store_time_close: { HH: "", mm: "" },
        store_day: 4,
        store_period: 1,
      },
      {
        store_time_open: { HH: "", mm: "" },
        store_time_close: { HH: "", mm: "" },
        store_day: 4,
        store_period: 2,
      },
      {
        store_time_open: { HH: "", mm: "" },
        store_time_close: { HH: "", mm: "" },
        store_day: 5,
        store_period: 1,
      },
      {
        store_time_open: { HH: "", mm: "" },
        store_time_close: { HH: "", mm: "" },
        store_day: 5,
        store_period: 2,
      },
      {
        store_time_open: { HH: "", mm: "" },
        store_time_close: { HH: "", mm: "" },
        store_day: 6,
        store_period: 1,
      },
      {
        store_time_open: { HH: "", mm: "" },
        store_time_close: { HH: "", mm: "" },
        store_day: 6,
        store_period: 2,
      },
      {
        store_time_open: { HH: "", mm: "" },
        store_time_close: { HH: "", mm: "" },
        store_day: 7,
        store_period: 1,
      },
      {
        store_time_open: { HH: "", mm: "" },
        store_time_close: { HH: "", mm: "" },
        store_day: 7,
        store_period: 2,
      },
    ],
  }),
  watch: {
    store_time_id: function() {
      this.resetTime();
      this.getStoreTimeData(this.store_time_id);
    },
  },
  components: { VueTimepicker, moment },
  methods: {
    selectedTimeOpen(value, day_id) {
      this.storeTime[(day_id - 1) * 2]["store_time_open"] = {
        HH: value.data.HH,
        mm: value.data.mm,
      };
      // value.data.HH + ":" + value.data.mm;
      // if (value.data.HH == "" || value.data.mm == "") {
      //   this.storeTime[(day_id - 1) * 2]["store_time_open"] = {
      //     HH: "",
      //     mm: "",
      //   };
      // }
    },
    selectedTimeClose(value, day_id) {
      this.storeTime[(day_id - 1) * 2]["store_time_close"] = {
        HH: value.data.HH,
        mm: value.data.mm,
      };
      // value.data.HH + ":" + value.data.mm;
      // if (value.data.HH == "" || value.data.mm == "") {
      //   this.storeTime[(day_id - 1) * 2]["store_time_close"] = {
      //     HH: "",
      //     mm: "",
      //   };
      // }
    },
    selectedTimeOpen2(value, day_id) {
      this.storeTime[day_id * 2 - 1]["store_time_open"] = {
        HH: value.data.HH,
        mm: value.data.mm,
      };
      // value.data.HH + ":" + value.data.mm;
      // if (value.data.HH == "" || value.data.mm == "") {
      //   this.storeTime[day_id * 2 - 1]["store_time_open"] = { HH: "", mm: "" };
      // }
    },
    selectedTimeClose2(value, day_id) {
      this.storeTime[day_id * 2 - 1]["store_time_close"] = {
        HH: value.data.HH,
        mm: value.data.mm,
      };
      // value.data.HH + ":" + value.data.mm;
      // if (value.data.HH == "" || value.data.mm == "") {
      //   this.storeTime[day_id * 2 - 1]["store_time_close"] = { HH: "", mm: "" };
      // }
    },
    indeterminateTime(item, day_id) {
      item.more = false;
      this.storeTime[day_id * 2 - 1]["store_time_open"] = { HH: "", mm: "" };
      this.storeTime[day_id * 2 - 1]["store_time_close"] = { HH: "", mm: "" };
    },

    async updateDineInStoreTime() {
      var payload_store_time = [];
      for (let i = 0; i < this.storeTime.length; i++) {
        let json = {
          store_time_open:
            this.storeTime[i].store_time_open.HH === "" ||
            this.storeTime[i].store_time_open.mm === ""
              ? "00:00"
              : this.storeTime[i].store_time_open.HH +
                ":" +
                this.storeTime[i].store_time_open.mm,
          store_time_close:
            this.storeTime[i].store_time_close.HH === "" ||
            this.storeTime[i].store_time_close.mm === ""
              ? "00:00"
              : this.storeTime[i].store_time_close.HH +
                ":" +
                this.storeTime[i].store_time_close.mm,
          store_day: this.storeTime[i].store_day,
          store_period: this.storeTime[i].store_period,
        };

        const open = new Date("2022-10-26 " + json.store_time_open);
        const close = new Date("2022-10-26 " + json.store_time_close);
        const res = moment(open).isAfter(close);

        if (res == true) {
          this.error_dialog = true;
          return;
        }

        if (i % 2 === 1) {
          let json2 = {
            store_time_open:
              this.storeTime[i - 1].store_time_open.HH === "" ||
              this.storeTime[i - 1].store_time_open.mm === ""
                ? "00:00"
                : this.storeTime[i - 1].store_time_open.HH +
                  ":" +
                  this.storeTime[i - 1].store_time_open.mm,
            store_time_close:
              this.storeTime[i - 1].store_time_close.HH === "" ||
              this.storeTime[i - 1].store_time_close.mm === ""
                ? "00:00"
                : this.storeTime[i - 1].store_time_close.HH +
                  ":" +
                  this.storeTime[i - 1].store_time_close.mm,
            store_day: this.storeTime[i - 1].store_day,
            store_period: this.storeTime[i - 1].store_period,
          };
          const open2 = new Date("2022-10-26 " + json2.store_time_open);
          const close2 = new Date("2022-10-26 " + json2.store_time_close);

          if (this.timeItems[(i - 1) / 2].more == true) {
            const res2 = moment(open).isBefore(open2);
            const res3 = moment(close).isBefore(close2);
            const res4 = moment(close).isBefore(open2);
            const res5 = moment(open).isBefore(close2);
            if (res2 == true || res3 == true || res4 == true || res5 == true) {
              this.error_dialog = true;
              return;
            }
          }
        }
        payload_store_time.push(json);
      }
      var payload = {
        data: {
          store_id: this.store_time_id,
          store_time: payload_store_time,
        },
      };
      var res = await this.$store.dispatch(
        "fetchDineIn/updateDineInStoreTime",
        payload
      );
      if (res === false) {
        this.failed_dialog = true;
      } else {
        this.$emit("closeEditDialog");
      }
    },

    async getStoreTimeData(id) {
      var res = await this.$store.dispatch(
        "fetchDineIn/getDineInStoreTimeById",
        id
      );
      this.setData(res);
    },

    resetTime() {
      this.storeTime = [
        {
          store_time_open: { HH: "", mm: "" },
          store_time_close: { HH: "", mm: "" },
          store_day: 1,
          store_period: 1,
        },
        {
          store_time_open: { HH: "", mm: "" },
          store_time_close: { HH: "", mm: "" },
          store_day: 1,
          store_period: 2,
        },
        {
          store_time_open: { HH: "", mm: "" },
          store_time_close: { HH: "", mm: "" },
          store_day: 2,
          store_period: 1,
        },
        {
          store_time_open: { HH: "", mm: "" },
          store_time_close: { HH: "", mm: "" },
          store_day: 2,
          store_period: 2,
        },
        {
          store_time_open: { HH: "", mm: "" },
          store_time_close: { HH: "", mm: "" },
          store_day: 3,
          store_period: 1,
        },
        {
          store_time_open: { HH: "", mm: "" },
          store_time_close: { HH: "", mm: "" },
          store_day: 3,
          store_period: 2,
        },
        {
          store_time_open: { HH: "", mm: "" },
          store_time_close: { HH: "", mm: "" },
          store_day: 4,
          store_period: 1,
        },
        {
          store_time_open: { HH: "", mm: "" },
          store_time_close: { HH: "", mm: "" },
          store_day: 4,
          store_period: 2,
        },
        {
          store_time_open: { HH: "", mm: "" },
          store_time_close: { HH: "", mm: "" },
          store_day: 5,
          store_period: 1,
        },
        {
          store_time_open: { HH: "", mm: "" },
          store_time_close: { HH: "", mm: "" },
          store_day: 5,
          store_period: 2,
        },
        {
          store_time_open: { HH: "", mm: "" },
          store_time_close: { HH: "", mm: "" },
          store_day: 6,
          store_period: 1,
        },
        {
          store_time_open: { HH: "", mm: "" },
          store_time_close: { HH: "", mm: "" },
          store_day: 6,
          store_period: 2,
        },
        {
          store_time_open: { HH: "", mm: "" },
          store_time_close: { HH: "", mm: "" },
          store_day: 7,
          store_period: 1,
        },
        {
          store_time_open: { HH: "", mm: "" },
          store_time_close: { HH: "", mm: "" },
          store_day: 7,
          store_period: 2,
        },
      ];
      this.timeItems = [
        {
          day_id: 1,
          days: "Sun",
          more: false,
        },
        {
          day_id: 2,
          days: "Mon",
          more: false,
        },
        {
          day_id: 3,
          days: "Tue",
          more: false,
        },
        {
          day_id: 4,
          days: "Wed",
          more: false,
        },
        {
          day_id: 5,
          days: "Thu",
          more: false,
        },
        {
          day_id: 6,
          days: "Fri",
          more: false,
        },
        {
          day_id: 7,
          days: "Sat",
          more: false,
        },
      ];
    },

    setData(res) {
      for (let j = 0; j < res.length; j++) {
        if (res[j].store_period == 2) {
          this.timeItems[res[j].store_time_id - 1].more = true;
        }
        for (let i = 0; i < this.storeTime.length; i++) {
          if (
            res[j].store_time_id === this.storeTime[i].store_day &&
            res[j].store_period === this.storeTime[i].store_period
          ) {
            var string = res[j].store_time_open.split(":");
            var string2 = res[j].store_time_close.split(":");
            const test = string[0] + ":" + string[1];
            const test2 = string2[0] + ":" + string2[1];
            if (test === "00:00" && test2 === "00:00") {
              this.timeItems[res[j].store_time_id - 1].more = false;
              this.storeTime[i].store_time_open = {
                HH: "",
                mm: "",
              };
              this.storeTime[i].store_time_close = {
                HH: "",
                mm: "",
              };
            } else {
              this.storeTime[i].store_time_open = {
                HH: string[0],
                mm: string[1],
              };
              this.storeTime[i].store_time_close = {
                HH: string2[0],
                mm: string2[1],
              };
            }
          }
        }
      }
    },
  },
};
</script>

<style scoped>
.info-header {
  margin-right: 10px;
  font-size: 18px;
  font-weight: 600;
}

.timePicker {
  margin-top: 15px;
}

.time-picker input.display-time {
  border: none;
}

.innerstore-timepicker {
  border: 1px solid #d2d2d2;
  width: auto;
}

.innerstore-timepicker:hover {
  border: 1px solid #333;
}

.time-picker .dropdown ul li.active,
.time-picker .dropdown ul li.active:hover {
  background: #ffd600;
  color: black;
}

.time-picker input.display-time {
  width: 9.3em;
  color: rgba(0, 0, 0, 0.54);
}
</style>
